import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import WidthContainer from '../../../components/WidthContainer'
import MaskedImage from '../../../components/MaskedImage'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'
import WavyBackground from '../../../components/WavyBackground'
import Socials from '../../../components/Socials'

const RootContainer = styled(WavyBackground)`
`

RootContainer.defaultProps = {
	type: 'gray',
}

const Title = styled.h2`
	margin-bottom: 3rem;
	
	@media only screen and (max-width: 550px) {
		text-align: center; 
	}
`

const List = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin: -2rem -1rem 2rem;
`


const Speaker = styled.div`
	width: 25%;	
	
	@media only screen and (max-width: 1100px) {
		width: 33.333%;
	}
	@media only screen and (max-width: 850px) { 
		width: 50%;
	}
	
	@media only screen and (max-width: 550px) { 
		width: 100%;
	}
`

const SpeakerInner = styled.div`
	margin: 2rem 1rem;
	text-align: center;
`

const SpeakerPhoto = styled(MaskedImage)`
	margin: 0 auto;
`

const SpeakerName = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.bold};
`

const SpeakerPosition = styled.div`
	margin-bottom: 1rem;
`

const SpeakerSocials = styled(Socials)`
	margin: -0.5rem;
	align-items: center;
	justify-content: center;
	
	> * {
		margin: 0.5rem;
	}

	 svg {
		fill: ${props => props.theme.colors.main};
		width: 1rem;
		transform: scale(1);
		transition: ${props => props.theme.transitions.smallElements} ease;
		
		&:hover {
			transform: scale(1.25);
		}
	 }
`

const SpeakerCompany = styled.div`
	margin-top: 1rem;
	font-size: ${props => props.theme.fontSizes.small};
	font-weight: ${props => props.theme.fontWeights.regular};
	color: ${props => props.theme.colors.grayText};
`

const SpeakersSection = ({className, data}) => <RootContainer className={className}>
	<WidthContainer>
		<Title>{data.title}</Title>

		<List>
			{data.list.map(one => <Speaker key={one.name}>
				<SpeakerInner>
					<SpeakerPhoto>
						<QueriedGatsbyImage image={one.photo}/>
					</SpeakerPhoto>
					<SpeakerName>{one.name}</SpeakerName>
					<SpeakerPosition>{one.position}</SpeakerPosition>
					<SpeakerSocials data={one.socials}/>
					<SpeakerCompany>{one.company}</SpeakerCompany>
				</SpeakerInner>
			</Speaker>)}
		</List>
	</WidthContainer>
</RootContainer>

SpeakersSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		list: PropTypes.arrayOf(PropTypes.shape({
			photo: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			position: PropTypes.string.isRequired,
			socials: PropTypes.shape({
				twitter: PropTypes.string.isRequired,
				linkedin: PropTypes.string.isRequired,
			}).isRequired,
			company: PropTypes.string.isRequired,
		}).isRequired).isRequired,
	}).isRequired,
}

SpeakersSection.defaultProps = {
	className: '',
}

export default SpeakersSection
